/* Lumi-noble — Wholesale page interactions
   Reveal on scroll (with failsafe) and anchor scrolling. */
(function () {
  'use strict';

  var REVEAL_SELECTOR = '.lnw-reveal';

  function revealAll() {
    document.querySelectorAll(REVEAL_SELECTOR).forEach(function (el) {
      el.classList.add('is-in-view');
    });
  }

  function initReveal() {
    var nodes = document.querySelectorAll(REVEAL_SELECTOR);
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      revealAll();
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in-view');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -50px 0px' }
    );

    nodes.forEach(function (el) {
      observer.observe(el);
    });

    // Failsafe: never leave content invisible if the observer misfires.
    window.setTimeout(revealAll, 2500);
  }

  function initAnchors() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-lnw-scroll]');
      if (!trigger) return;
      var hash = trigger.getAttribute('href');
      if (!hash || hash.charAt(0) !== '#') return;
      var target = document.querySelector(hash);
      if (!target) return;
      e.preventDefault();
      var header = document.querySelector('sticky-header, .header-wrapper, header');
      var offset = header ? header.getBoundingClientRect().height + 12 : 80;
      window.scrollTo({
        top: target.getBoundingClientRect().top + window.pageYOffset - offset,
        behavior: 'smooth'
      });
      history.replaceState(null, '', hash);
      var field = target.querySelector('input, select, textarea');
      if (field) {
        window.setTimeout(function () {
          field.focus({ preventScroll: true });
        }, 600);
      }
    });
  }

  function init() {
    initReveal();
    initAnchors();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', initReveal);
})();
